<section class="panel panel--warning mt-3" aria-labelledby="titulo-estado-acceso" data-testid="estado-acceso">
    <h2 id="titulo-estado-acceso" class="panel__title">Estado y acceso</h2>
    <p class="mb-2">Estado actual: <span class="badge" data-testid="estado-actual" [ngClass]="estadoActual === 'activa' ? 'bg-success' : estadoActual === 'desactivada' ? 'bg-danger' : 'bg-secondary'">{{ etiquetaActual }}</span></p>
    <p class="panel__lead">
        <strong>Desactivar una asociación bloquea su acceso</strong>: no podrá iniciar sesión (ni con contraseña ni con QR) y su sesión
        abierta perderá el acceso. No se borra ningún dato y se puede volver a activar. Este cambio es independiente del resto de
        datos del formulario y queda registrado en la auditoría.
    </p>
    @if (puedeCambiar) {
        <div class="form-grid align-items-end">
            <div>
                <label class="form-label" for="estado-selector">Estado</label>
                <select id="estado-selector" class="form-select" data-testid="estado-selector" [ngModel]="seleccion" (ngModelChange)="seleccionar($event)" [disabled]="guardando">
                    @if (estadoActual === 'sin-definir') { <option value="">Sin definir (elige un estado)</option> }
                    <option value="activa">Activa</option>
                    <option value="desactivada">Desactivada</option>
                </select>
            </div>
            <div>
                <button type="button" class="btn" data-testid="estado-aplicar" [ngClass]="seleccion === 'desactivada' ? 'btn-danger' : 'btn-primary'" [disabled]="!puedeAplicar" (click)="aplicar()">Aplicar estado</button>
            </div>
        </div>
        @if (pideConfirmacionExtra) {
            <div class="form-check mt-3" data-testid="estado-confirmacion-extra">
                <input class="form-check-input" type="checkbox" id="confirmo-bloqueo" [ngModel]="confirmoBloqueo" (ngModelChange)="confirmoBloqueo = $event" [disabled]="guardando">
                <label class="form-check-label" for="confirmo-bloqueo">Entiendo que esta asociación dejará de poder acceder.</label>
            </div>
        }
    } @else {
        <p class="small mb-0" data-testid="estado-sin-permiso"><i class="bi bi-lock-fill me-1" aria-hidden="true"></i>Solo las personas con el permiso «asociaciones:estado» pueden cambiar el estado.</p>
    }
</section>
